import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-carrier-spot-quote',
  templateUrl: './carrier-spot-quote.component.html',
  styleUrl: './carrier-spot-quote.component.scss'
})
export class CarrierSpotQuoteComponent {
  @Input() isVisible: boolean = false;
  @Input() alternateReference: string | null = '';

  @Output() close = new EventEmitter<void>();

  spotQuoteForm!: FormGroup;

  constructor(
    private fb: FormBuilder
  ){}

  ngOnInit(){
    this.spotQuoteForm = this.fb.group({
      rate: [0.0, Validators.required]
    })
  }

  onClose(): void {
    this.close.emit();
  }

  onSubmit(): void{
    this.onClose();
  }
}
